import { useEffect, useState } from "react";
import { TokenDropdownValue } from "@pages/token-screener/token-screener-header.tsx";

type SelectionState = {
  dropdownValue: TokenDropdownValue;
  showStarred: boolean;
};

const isDropdownValue = (value: unknown): value is TokenDropdownValue => {
  const validValues = ["recent", "history", "trending", "all", "positions"];
  return (
    typeof value === "string" &&
    validValues.includes(value as TokenDropdownValue)
  );
};

export const useTokenScreenerState = () => {
  const getInitialSelection = (): SelectionState => {
    const storedDropdown = sessionStorage.getItem("last_dropdown_value");
    const dropdownValue: TokenDropdownValue = isDropdownValue(storedDropdown)
      ? storedDropdown
      : "all";
    const showStarred = sessionStorage.getItem("last_selected") === "star";
    return { dropdownValue, showStarred };
  };

  const [selection, setSelection] =
    useState<SelectionState>(getInitialSelection);

  useEffect(() => {
    sessionStorage.setItem("last_dropdown_value", selection.dropdownValue);
    sessionStorage.setItem(
      "last_selected",
      selection.showStarred ? "star" : selection.dropdownValue,
    );
  }, [selection]);

  const setDropdown = (value: TokenDropdownValue) => {
    setSelection({ showStarred: false, dropdownValue: value });
  };

  const toggleStarred = () => {
    setSelection((prev) => {
      return {
        showStarred: !prev.showStarred,
        dropdownValue: prev.dropdownValue,
      };
    });
  };

  return {
    selection,
    setDropdown,
    toggleStarred,
  };
};
